import { i18n } from "next-i18next"

export const translate = (key: string, config?: any) => i18n && i18n.t(key, config).toString()
